import React, { FC } from 'react';

import { StyledItem } from './styled';

const MainMenuItem: FC<{ image: string }> = ({ image }) => (
  <StyledItem src={image} alt="user profile image" />
);

export default MainMenuItem;
